module.exports = __webpack_public_path__ + "img/bigLogo.09118523.png";